import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store/index';
import './locales/i18n';
import Head from './components/head/Head';
import Spinner from './components/material-ui/spinner/Spinner';

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      <Head />
      <App />
    </Suspense>
  </Provider>
);
